<template>
    <div class="animate-pulse">
      <!-- Barra de progreso -->
      <div v-if="showProgressBar" class="w-full bg-gray-200 rounded-full h-1.5 mb-4">
        <div class="bg-navy h-1.5 rounded-full" :style="{ width: `${progress}%` }"></div>
      </div>
      <!-- Texto dinámico -->
      <div v-if="loadingText" class="text-center">
        <p class="mb-5">{{ loadingText }}</p>
      </div>
      <!-- Skeleton loader -->
      <v-skeleton-loader
        v-for="(index) in skeletonCount"
        :key="index"
        :class="customSkeletonClass"
        max-width="800"
        :type="skeletonType"
      ></v-skeleton-loader>
    </div>
  </template>

  <script>
  export default {
    props: {
      progress: {
        type: Number,
        default: 0,
      },
      loadingText: {
        type: String,
        default: "",
      },
      skeletonCount: {
        type: Number,
        default: 2,
      },
      customSkeletonClass: {
        type: String,
        default: "custom-skeleton",
      },
      skeletonType: {
        type: String,
        default: "table",
      },
      showProgressBar: {
        type: Boolean,
        default: true,
      },
    },
  };
  </script>

  <style scoped>
  .custom-skeleton {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    margin-bottom: 20px;
  }

  .bg-navy {
    background-color: #1a2a6c;
  }

  .animate-pulse {
    animation: pulse 1.5s ease-in-out infinite;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
  </style>
